/* eslint-disable react/prop-types */
import { useState } from 'react';
import { useFetchUserCountReport } from './Hook/Index';
import { Row, Col, Card, DatePicker, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import ReportTrendChart from './ReportTrendChart';

const { RangePicker } = DatePicker;
const { useBreakpoint } = Grid;

export default function UserCountTab({ operatorId, active = false }) {
  const { t } = useTranslation('reportPage');
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
    dayjs().format('YYYY-MM-DD'),
  ]);
  const { data, isLoading } = useFetchUserCountReport(
    {
      operatorId,
      fromDate: dateRange[0],
      toDate: dateRange[1],
    },
    { enabled: active }
  );

  return (
    <div style={{ padding: '0 8px' }}>
      <RangePicker
        className={`${isMobile ? 'w-full' : 'max-w-[300px]'} mb-4`}
        value={
          dateRange.length === 2
            ? [dayjs(dateRange[0]), dayjs(dateRange[1])]
            : null
        }
        onChange={(dates) =>
          setDateRange(
            dates
              ? [
                  dayjs(dates[0]).format('YYYY-MM-DD'),
                  dayjs(dates[1]).format('YYYY-MM-DD'),
                ]
              : []
          )
        }
      />
      <Row gutter={[16, 16]} className="mb-4">
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card size="small" title={t('totalUsers')} loading={isLoading}>
            <div className="text-2xl text-center font-bold text-[#1890ff]">
              {data?.userCount || 0}
            </div>
          </Card>
        </Col>
      </Row>
      <ReportTrendChart
        title={t('userCountTrend')}
        series={data?.series}
        loading={isLoading}
        fields={[
          { key: 'userCount', label: t('totalUsers') },
          { key: 'added', label: t('added') },
        ]}
      />
    </div>
  );
}

UserCountTab.propTypes = {
  operatorId: PropTypes.string,
  active: PropTypes.bool,
};
